export const DECLINE_MODAL_ID = "decline-company-modal";

export const VERIFY_MODAL_ID = "verify-company-modal";

export const CLASS_NAMES = {
  title: "mb-2 text-14-22-em text-neutral-600",
};
